import { Routes } from "@angular/router";

export const appRoutes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("@modules/auth/auth.routes").then((m) => m.authRoutes),
  },
  {
    path: "public",
    loadChildren: () =>
      import("./public/public.routes").then((m) => m.publicRoutes),
  },
  {
    path: "error",
    loadChildren: () =>
      import("@modules/errors/errors.routes").then((m) => m.errorsRoutes),
  },
  {
    path: "",
    loadChildren: () =>
      import("./_metronic/layout/layout.routes").then((m) => m.layoutRoutes),
  },
  { path: "**", redirectTo: "error/404", pathMatch: "full" },
];
